import React from 'react';
import { Button } from '@mui/material';

import useSettings from '../../hooks/useSettings';
import FilesViewer from '../../files-viewer/FilesViewer';

interface UploadStepProps {
	fileBlob?: string;
	setFileBlob: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export default function UploadStep(props: UploadStepProps) {
	const { t } = useSettings();

	const pickerRef = React.createRef<HTMLInputElement>();

	const [fileType, setFileType] = React.useState<string>('xls');

	function changeFile(event) {
		event.preventDefault();

		const image = event.target.files[0];
		setFileType(image.type === 'text/csv' ? 'csv' : 'xls');

		const reader = new FileReader();
		reader.addEventListener('load', () => props.setFileBlob(reader.result as string));
		reader.readAsDataURL(image);
	}

	return (
		<div className="flex flex-col overflow-y-auto p-16">
			<Button className="mb-16" variant="contained" onClick={() => pickerRef.current?.click()}>
				{t('FILE_EXPLORER_UPLOAD_FILE')}
			</Button>
			<input
				ref={pickerRef}
				id="outlined-button-file"
				type="file"
				accept=".csv, .xls, .xlsx"
				className="hidden"
				onChange={changeFile}
			/>
			{!!props.fileBlob && (
				<FilesViewer
					className="flex flex-col overflow-y-auto"
					fileType={fileType}
					filePath=""
					fileEncoded={props.fileBlob.split(',')[1] || ''}
				/>
			)}
		</div>
	);
}
